import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, excludeRoles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // ALWAYS show loading spinner while auth state is being determined
  // This completely prevents any flash during page refresh
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--pf-canvas)]">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-4 border-[var(--pf-accent)]"></div>
          <p className="mt-4 text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  // Only redirect to login after loading is complete and user is still null
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    // Redirect based on user role
    const redirectTo = user.role === 'caregiver' ? '/caregiver-dashboard' : '/owner-dashboard';
    return <Navigate to={redirectTo} replace />;
  }

  // Check if user role is excluded from this route
  if (excludeRoles.includes(user.role)) {
    // Redirect excluded roles to their appropriate dashboard
    const redirectTo = user.role === 'admin' 
      ? '/admin-dashboard' 
      : user.role === 'caregiver' 
        ? '/caregiver-dashboard' 
        : '/owner-dashboard';
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
